import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProductCard from "./ProductCard";
import { productsService } from "../../services/products";

function SkeletonCard() {
  return (
    <div className="rounded-sm overflow-hidden border border-gray-100 animate-pulse">
      <div className="bg-gray-200 aspect-[3/4]" />
      <div className="p-4">
        <div className="h-5 bg-gray-200 rounded mb-2 w-3/4" />
        <div className="h-3 bg-gray-100 rounded mb-4" />
        <div className="h-8 bg-gray-200 rounded w-full" />
      </div>
    </div>
  );
}

export default function FeaturedProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const loadProducts = async () => {
      const nextProducts = await productsService.fetchStorefrontProducts();
      if (!active) return;
      setProducts(nextProducts);
      setLoading(false);
    };

    loadProducts();

    const channel = productsService.subscribeToProducts(() => {
      loadProducts();
    });

    return () => {
      active = false;
      channel?.unsubscribe();
    };
  }, []);

  const featuredProducts = products.filter((product) => product.featured).slice(0, 6);
  const displayProducts = featuredProducts.length > 0 ? featuredProducts : products.slice(0, 6);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-14">
          <span className="section-label">Curated For You</span>
          <h2 className="section-title mt-3">Our Featured Collection</h2>
          <div className="mt-5 flex justify-center"><div className="w-10 h-px bg-brand-red" /></div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {loading
            ? Array.from({ length: 6 }, (_, index) => <SkeletonCard key={index} />)
            : displayProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
        </div>

        <div className="text-center mt-14">
          <Link to="/products" className="btn-primary group">
            Shop All Fragrances
            <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-200" />
          </Link>
        </div>
      </div>
    </section>
  );
}
